<template>
  <div class="dashboard">
    <!-- Stats Section -->
    <div class="stats-container">
      <div class="stat-item">
        <h3>Today's Inspections</h3>
        <p>{{ todayTotalInspection }}</p> <!-- Example data -->
      </div>
      <div class="stat-item">
        <h3>Completed Inspections</h3>
        <p>{{ todaySubmittedInspection }}</p> <!-- Example data -->
      </div>
      <div class="stat-item">
        <h3>Closed Inspections</h3>
        <p>{{ todayCloseInspection }}</p> <!-- Example data -->
      </div>
    </div>

    <!-- Inspections Section -->
    <div class="inspection-section">
      <!-- Submitted Inspections -->
      <div class="inspection-container">
        <h2>Today's Submitted Inspections</h2>
        
        <div v-for="item in submittedItems" :key="item._id" class="inspection-item">
          
          <!-- Title of the Inspection -->
          <div class="inspection-title">{{ item.title }}</div>
          
          <!-- Client Name -->
          <div class="inspection-client" v-if="item.clientId">{{ item.clientId.companyName }}</div>
          
          <!-- Inspector Name -->
          <div class="inspection-inspector">{{ item.inspectorName }}</div>
          
          <!-- View Icon -->
          <div class="view-icon" @click="$router.push({ path: 'inspection-data', query: { id: item._id }})">
            <i class="fas fa-eye"></i>
          </div>
          
        </div>
      </div>


      <!-- Open Inspections -->
      <div class="inspection-container">
        <h2>Today's Open Inspections</h2>
        <div v-for="item in openItems" :key="item._id" class="inspection-item">
          
          <!-- Title of the Inspection -->
          <div class="inspection-title">{{ item.title }}</div>
          
          <!-- Client Name -->
          <div class="inspection-client" v-if="item.clientId">{{ item.clientId.companyName }}</div>
          
          <!-- Inspector Name -->
          <div class="inspection-inspector">{{ item.inspectorName }}</div>
          
          <!-- View Icon -->
          <div class="view-icon" @click="$router.push({ path: 'inspection-data', query: { id: item._id }})">
            <i class="fas fa-eye"></i>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UsersDataService from "../../services/UsersDataService";
export default {
  data() {
    return {
      // Static data for example, replace with dynamic data
      submittedItems: [],
      openItems: [],
      todayTotalInspection: 0,
      todaySubmittedInspection: 0,
      todayCloseInspection: 0,
    };
  },
  methods: {
    getDashboardData() {
      let data = {
      }
      UsersDataService.getDashboardData(data)
        .then((response) => {
            this.todayTotalInspection = response.data.data.todayTotalInspection
            this.todaySubmittedInspection = response.data.data.todaySubmittedInspection
            this.todayCloseInspection = response.data.data.todayCloseInspection
            this.submittedItems = response.data.data.submittedInspectionList
            this.openItems = response.data.data.openInspectionList
        }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
        });
    },
  },
  beforeMount() {
    this.getDashboardData()
  },
};
</script>

<style scoped>
/* General Container */
.dashboard {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

/* Stats Section Styles */
.stats-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.stat-item {
  background-color: #fff;
  padding: 5px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.stat-item h3 {
  font-size: 18px;
  color: #333;
}

.stat-item p {
  font-size: 28px;
  font-weight: bold;
  color: #007bff;
}

/* Inspection Section */
.inspection-section {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
}

.inspection-container {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 48%; /* 2 blocks side by side */
  margin-bottom: 20px;
}

h2 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 20px;
  color: #333;
}

/* Inspection Item Styles */
.inspection-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
}

.inspection-item:last-child {
  border-bottom: none;
}

.inspection-name {
  font-size: 16px;
  color: #333;
}

.view-icon {
  color: #007bff;
  cursor: pointer;
}

.view-icon:hover {
  color: #0056b3;
}

/* Mobile Friendly Styles */
@media (max-width: 768px) {
  .stats-container {
    grid-template-columns: 1fr; /* Stacks stats vertically on smaller screens */
  }

  .inspection-section {
    flex-direction: column; /* Stack inspection sections vertically */
  }

  .inspection-container {
    width: 100%; /* Ensure full width on mobile */
  }

  h2 {
    font-size: 18px;
  }

  .inspection-name {
    font-size: 14px;
  }

  .stat-item h3 {
    font-size: 16px;
  }

  .stat-item p {
    font-size: 22px;
  }
}

.inspection-title {
  font-weight: bold;
  color: #333;
}

.inspection-client,
.inspection-inspector {
  font-size: 14px;
  color: #555;
}

.view-icon {
  color: #007bff;
  cursor: pointer;
}

.view-icon:hover {
  color: #0056b3;
}

</style>
